import { render } from "./HeaderFixed.vue?vue&type=template&id=8455baac"
import script from "./HeaderFixed.vue?vue&type=script&lang=js"
export * from "./HeaderFixed.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__